<template>
  <div>
    <BaseTextH1 has-wrapper>
      {{ $t('top-scorers') }}
    </BaseTextH1>
    <BaseLoading v-if="isTopScorersLoading" />
    <template v-else>
      <b-row
        class="d-flex justify-content-center"
        :class="$style.topScorers"
      >
        <b-col
          :cols="12"
          :sm="6"
          :md="5"
        >
          <TheAthleteGoalsOverviewCard
            v-for="athlete in team1TopScorers"
            :id="athlete.id"
            :key="athlete.id"
            :name="athlete.name"
            :avatar="athlete.image"
            :score="athlete.totalScore"
          />
        </b-col>
        <b-col
          :cols="12"
          :sm="6"
          :md="5"
        >
          <TheAthleteGoalsOverviewCard
            v-for="athlete in team2TopScorers"
            :id="athlete.id"
            :key="athlete.id"
            :name="athlete.name"
            :avatar="athlete.image"
            :score="athlete.totalScore"
          />
        </b-col>
      </b-row>
    </template>

    <BaseTextH1 has-wrapper>
      {{ $t('history') }}
    </BaseTextH1>
    <template v-if="!history.length">
      <TheMatchDetailRow
        v-for="match in history"
        :key="match.id"
        :match="match"
      />
    </template>
    <BaseAlert
      v-else
      is-center
      variant="light"
    >
      {{ $t('there-are-no-passed-matches-for-team1-and-team2', {
        team1Name: team1name[$i18n.locale],
        team2Name: team2name[$i18n.locale]
      }) }}
    </BaseAlert>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TheMatchDetailRow from '@/components/Molecules/TheMatchDetailRow'
import BaseLoading from '@/components/Atoms/BaseLoading'
import TheAthleteGoalsOverviewCard from '@/components/Molecules/TheAthleteGoalsOverviewCard'
import BaseTextH1 from '@/components/Atoms/Typography/BaseTextH1'
import BaseAlert from '@/components/Atoms/BaseAlert'

export default {
  name: 'MatchUpcoming',
  components: {
    BaseAlert,
    BaseTextH1,
    TheAthleteGoalsOverviewCard,
    BaseLoading,
    TheMatchDetailRow,
  },
  props: {
    history: {
      type: Array,
      required: true,
    },
    team1id: {
      type: Number,
      required: true,
    },
    team1name: {
      type: Object,
      required: true,
    },
    team2id: {
      type: Number,
      required: true,
    },
    team2name: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      getScorePlayers: 'teams/topScorers/getTeamTopScorers',
      isTopScorerLoading: 'teams/topScorers/getIsTeamTopScorersLoading',
    }),
    isTopScorersLoading() {
      return this.isTopScorerLoading(this.team1id) || this.isTopScorerLoading(this.team2id)
    },
    team1TopScorers() {
      return this.getScorePlayers(this.team1id)
    },
    team2TopScorers() {
      return this.getScorePlayers(this.team2id)
    },
  },
}
</script>

<style module lang="scss">
  @import "../../../assets/scss/variables";
  .topScorers {
    background-color: $color-white;
  }
</style>
